<template>
  <div>
    <v-card>
      <v-card-title>Estatus de Guía</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-card
              outlined
              elevation="5"
            >
              <v-card-subtitle>Estatus</v-card-subtitle>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-combobox
                        v-model="estatus"
                        label="Estatus"
                        required
                        :rules="[reglas.requeridoTxt]"
                        :items="lstEstatus"
                        item-value="id"
                        item-text="descripcion"
                        :disabled="disabled"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-dialog
                        ref="dialogFecha"
                        v-model="modalFecha"
                        :return-value.sync="fecha"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fecha"
                            label="Fecha"
                            append-icon="event"
                            readonly
                            v-bind="attrs"
                            :rules="[reglas.requeridoTxt]"
                            required
                            :disabled="disabled"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="fecha"
                          scrollable
                          no-title
                          @input="
                            modalFecha = false;
                            $refs.dialogFecha.save(fecha);
                          "
                        />
                      </v-dialog>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-dialog
                        ref="dialogHora"
                        v-model="modalHora"
                        :return-value.sync="hora"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="hora"
                            label="Hora"
                            append-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            :rules="[reglas.requeridoTxt]"
                            required
                            :disabled="disabled"
                            v-on="on"
                          />
                        </template>
                        <v-time-picker v-model="hora">
                          <v-spacer />
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialogHora.save(hora)"
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-text-field
                        v-model="comentarios"
                        label="Comentarios"
                        :disabled="disabled"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer /><v-btn
                  outlined
                  color="primary"
                  elevation="5"
                  :disabled="disabled"
                  @click="addEstatusGuia()"
                >
                  Agregar Estatus
                  <v-icon>mdi-arrow-right-bold-circle</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card
              outlined
              elevation="5"
            >
              <v-card-subtitle>Historial</v-card-subtitle>
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="estatusDeGuia"
                >
                  <template v-slot:item.acciones="{ item }">
                    <v-btn
                      icon
                      color="red"
                      :disabled="disabled"
                      @click="deleteStatus(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  elevation="5"
                  outlined
                  :disabled="disabled"
                  @click="finalizar()"
                >
                  Finalizar <v-icon>mdi-book-check</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import apicon from '../plugins/apicon'
export default {
  props: {
    id: {
      type: Number,
      default: null
    },
    finalizado: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalFecha: false,
      modalHora: false,
      valid: true,
      headers: [
        { text: 'Estatus', value: 'estatus.descripcion' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Hora', value: 'hora' },
        { text: 'Comentarios', value: 'comentarios' },
        { text: 'Acciones', value: 'acciones' }
      ],
      estatusDeGuia: [],
      lstEstatus: [],
      estatus: null,
      fecha: null,
      hora: null,
      comentarios: null,
      disabled: false
    }
  },
  created: function () {},
  mounted: function () {
    this.getEstatusDeGuia()
    this.getLstEstatus()
    this.disabled = this.finalizado
  },
  methods: {
    getEstatusDeGuia: function () {
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() + 'guias/historialestatus/' + this.id
        )
        .then((result) => {
          this.estatusDeGuia = result
        })
    },
    getLstEstatus: function () {
      apicon
        .getDataApi(apicon.getApiBaseUrl() + 'estatusall')
        .then((result) => {
          this.lstEstatus = result
        })
    },
    addEstatusGuia: function () {
      if (this.$refs.form.validate()) {
        var datos = {
          id_guia: this.id,
          id_estatus: this.estatus.id,
          fecha: this.fecha,
          hora: this.hora,
          comentarios: this.comentarios
        }
        apicon
          .saveDataApi(apicon.getApiBaseUrl() + 'guias/addestatus', datos)
          .then(async (result) => {
            this.getEstatusDeGuia()
            if (result.status) {
              await this.limpiar()
            }
            this.$swal(result.message)
          })
      }
    },
    limpiar: function () {
      this.$refs.form.resetValidation()
      this.estatus = null
      this.fecha = null
      this.hora = null
      this.comentarios = null
    },
    deleteStatus: function (item) {
      var self = this
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          var url = apicon.getApiBaseUrl() + 'guias/delestatus/' + item.id
          apicon.deleteDataApi(url).then((result) => {
            self.getEstatusDeGuia()
            this.$swal(result.message)
          })
        }
      })
    },
    finalizar: function () {
      var self = this
      this.$swal({
        title: 'Alerta',
        text: 'Desea finalizar esta guía, posterior a esto ya no se podran agregar mas estatus',
        icon: 'warning',
        showCancelButton: true
      }).then((resultdlg) => {
        if (resultdlg.value) {
          apicon.saveDataApi(apicon.getApiBaseUrl() + 'guias/finalizar/' + self.id).then((result) => {
            if (result.status) {
              self.disabled = true
            }
            this.$swal(result.message)
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
